/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Po_Not_ConfirmedInputs */

const en_inbound_issue_po_not_confirmed = /** @type {(inputs: Inbound_Issue_Po_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the purchase order is not confirmed by the supplier`)
};

/**
* | output |
* | --- |
* | "the purchase order is not confirmed by the supplier" |
*
* @param {Inbound_Issue_Po_Not_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_po_not_confirmed = /** @type {((inputs?: Inbound_Issue_Po_Not_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Po_Not_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_po_not_confirmed(inputs)
});